import {useTranslation} from 'react-i18next';

import {I18nKey} from './i18nKey';
import {SupportedLocale} from './localeService';

export const useT = (): ((key: I18nKey, params?: Record<string, unknown>) => string) => {
    const {t} = useTranslation();
    return (key, params) => t(key, params);
};

export const useTReason = (): ((code: string | null | undefined, fallback: string) => string) => {
    const {t} = useTranslation();
    return (code, fallback) => (code ? t(`system.${code}`, {defaultValue: fallback}) : fallback);
};

export const useCurrentLocale = (): SupportedLocale => {
    const {i18n} = useTranslation();
    return i18n.language as SupportedLocale;
};
